// The contactless-payment symbol (Apple's wave.3.right.circle): a circle
// containing three arcs radiating right. Drawn as SVG so the web layer can
// show the same mark Apple requires on the Tap to Pay on iPhone button.
export default function ContactlessIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M8.6 10.6c0.75 0.8 0.75 2 0 2.8" />
      <path d="M11 9c1.55 1.6 1.55 4.4 0 6" />
      <path d="M13.4 7.4c2.35 2.4 2.35 6.8 0 9.2" />
    </svg>
  );
}
